var map = {
	"./backoffice.png": 320,
	"./campanhas.png": 321,
	"./cobranca.png": 322,
	"./endosso.png": 323,
	"./linha.png": 324,
	"./sinistros.png": 325,
	"./vendas.png": 326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;